// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1fSe0","title":"ClientReferral_title__3Dvv0","itemText":"ClientReferral_itemText__18rln"};